// jshint module: true

// Enable hover(), focus() and hover-and-focus() mixins
document.body.classList.add(('ontouchstart' in window) ? 'touch' : 'no-touch');



// WEBPACK FOOTER //
// ./website/assets/scripts/polyfills/enable-hover-focus-mixins.js